// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerLineMenu__link__count":"fj_a bhj_fk","SellerLineMenu__link--active":"fj_b bhj_ef"};